module.exports = __webpack_public_path__ + "img/4.1.9070b5f1.png";